module.exports = __webpack_public_path__ + "img/2.e4262b01.png";